<template>
  <ul class="list">
    <li v-if="theme_store.themeData.showSearch" @click="handleSearch">
      <el-tooltip content="搜索">
        <el-icon><Search /></el-icon>
      </el-tooltip>
    </li>
    <li v-if="theme_store.themeData.showLock" @click="handleLock">
      <el-tooltip content="锁屏">
        <el-icon><Lock /></el-icon>
      </el-tooltip>
    </li>
    <li v-if="theme_store.themeData.showRefresh" @click="handleReFresh">
      <el-tooltip content="刷新">
        <el-icon><Refresh /></el-icon>
      </el-tooltip>
    </li> 
    <li v-if="theme_store.themeData.showLanguage">
      <el-tooltip content="国际化">
        <el-dropdown trigger="click" @command="handleCommand">
          <el-icon :size="16"><Basketball /></el-icon>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(item, i) in useI18nStore.localeList"
                :disabled="useI18nStore.GetComlocale==item.value"
                :command="item.value"
                >{{ $t(item.label) }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-tooltip>
    </li>
    <li v-if="theme_store.themeData.isSize">
      <el-tooltip content="组件大小">
        <el-dropdown trigger="click" @command="handleCommand_size">
          <svg-icon icon-class="size" size="16"/>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(item, i) in state.sizeList"
                :disabled="theme_store.theme.size==item.value"
                :command="item.value"
                >{{ $t(item.label) }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-tooltip>
    </li>
    <li v-if="theme_store.themeData.showTheme" @click="handleTheme">
      <el-tooltip content="主题">
        <el-icon ><Brush /></el-icon>
      </el-tooltip>
    </li>
    <li v-if="theme_store.themeData.showFullScreen" @click="toggle">
      <el-tooltip content="全屏">
        <el-icon :size="14" ><FullScreen /></el-icon>
      </el-tooltip>
    </li>
    <el-tooltip content="通知">
    <li v-if="theme_store.themeData.showNotice" @click="handleNotice">
        <el-popover :width="320" trigger="click">
          <template #reference>
            <el-badge :value="2" :offset="[0, 0]">
              <el-icon ><Bell /></el-icon>
            </el-badge>
          </template>
          <el-tabs v-model="state.activeName">
            <el-tab-pane label="通知" name="notification"></el-tab-pane>
            <el-tab-pane label="邮件" name="email"></el-tab-pane>
          </el-tabs>
          <div
            v-infinite-scroll="load"
            style="height: 294px; overflow-y: auto"
            :infinite-scroll-disabled="state.disabled"
            v-if="state.activeName == 'notification'"
          >
            <el-link
              href="https://element-plus.org"
              target="_blank"
              v-for="item in state.count"
              :key="item"
              style="line-height: 28px"
              >{{ item }}</el-link
            >
            <el-empty description="暂无通知" v-if="state.count.length == 0" />
          </div>
          <div v-if="state.activeName == 'email'">
            <el-empty description="暂无邮件" />
          </div>
          <el-divider />
          <div class="clearInfo" pointer>
            <el-button type="primary" link @click="clearNotific"
              ><el-icon><CircleClose /></el-icon>清空消息</el-button
            >
          </div>
        </el-popover>
    </li>
  </el-tooltip>
  </ul>

  <!-- 搜索 -->
  <el-dialog
    draggable
    :show-close="false"
    :model-value="state.dialogVisible"
    :before-close="handleClose"
    width="50%"
  >
    <el-form :model="state.form" @submit.native.prevent>
      <el-form-item label=" ">
        <el-input
          v-model="state.form.name"
          style="height: 60px"
          @keydown.enter="handleDown"
        >
          <template #prefix>
            <el-icon class="el-input__icon" style="font-size: 20px"
              ><search
            /></el-icon>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 锁屏 -->
  <teleport to="body">
    <transition name="move">
      <Lockoverlay v-if="UserStore.LockComputed"></Lockoverlay>
    </transition>
  </teleport>
</template>
<script setup>
// 头部工具栏
import {
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
} from "vue";
import { useRouter } from "vue-router";
import {
  TagviewsStore,
  i18nStore,
  themeStore,
  UserInfoStore,
} from "@/stores/index.js";
import { storeToRefs } from "pinia";
import { SetStorage, GetStorage } from "@/utils/auth.js";

import {useFullscreen} from "@vueuse/core";
const { isFullscreen, toggle } = useFullscreen()
import { watch } from "vue";
const useViewStore = TagviewsStore();
const useI18nStore = i18nStore();
const theme_store = themeStore();
const UserStore = UserInfoStore();
const  { theme } = storeToRefs(theme_store)
defineOptions({
  name: "Tool",
});
const router = useRouter();
const state = reactive({
  visible: false,
  isShow: false,
  dialogVisible: false,
  isPopover: false,
  activeName: "notification",
  form: {
    name: "",
  },
  count: ["响应式布局适配兼容电脑、平板"],
  disabled: false,
  sizeList:[
    {
      value:'default',
      label:"message.size.default"
    },
    {
      value:'large',
      label:"message.size.large"
    },
    {
      value:'small',
      label:"message.size.small"
    },
  ]
});

const handleClose = () => {
  state.dialogVisible = false;
  state.form.name = "";
};
const handleDown = (e) => {
  window.open("https://www.baidu.com/baidu?wd=" + state.form.name);
};
// 锁屏
const handleLock = () => {
  UserStore.$patch({
    Lockvisible: true,
  });
  SetStorage("Lockvisible", true);
};
// 搜索
const handleSearch = () => {
  state.dialogVisible = true;
};

// 通知
const handleNotice = () => {};
const clearNotific = () => {
  state.count = [];
};
const load = () => {
  if (state.count.length == 2) {
    state.disabled = true;
    return;
  } else {
    state.count = [...state.count, "vite搭建,开发速度快,友好的交互体验"];
  }
};
// 国际化
const handleCommand = (v) => {
  useI18nStore.EditLocale(v);
};
// 组件大小
const handleCommand_size = (v)=>{
  theme.value.size = v
  theme_store.saveTheme()
}
// 主题
const handleTheme = () => {
  theme_store.visible=true
};
// 刷新
const handleReFresh = () => {
  useViewStore.refreshCurrentView();
};
onMounted(() => {
  // window+j 快速锁屏
  document.addEventListener("keyup", (e) => {
    if (e.keyCode == 74 && e.metaKey) {
      UserStore.$patch({
        Lockvisible: true,
      });
      SetStorage("Lockvisible", true);
    }
  });
});
onBeforeUnmount(() => {
});
</script>
<style lang="scss" scoped>
.list {
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
  padding-left: 0;
  li {
    margin: 0 0 0 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.clearInfo {
  text-align: center;
}

</style>

